<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3" class="content_category rounded-lg ml-3">
        <div class="mx-2" style="width: 90%">
          <v-row>
            <v-col cols="8">
              <h4 class="mb-1">Tin hay</h4>
            </v-col>
            <v-col cols="4">
              <v-btn
                class="d-flex justify-end"
                color="primary"
                @click="addBlockCategory()" 
              >
                ADD
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-col cols="12"
            v-for="(i, index) in post_config_sidebar.category_post_ids"
            :key="index"
          >
            <v-row class="ma-0 pa-0">
              <v-col cols="8" class="ma-0 pa-0">
                <v-autocomplete
                  v-model="i.category_post_id"
                  label="Chọn danh mục"
                  :items="categoryPost"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" class="ma-0 pa-0">
                <v-btn
                  class="ma-2"
                  outlined
                
                  large
                  color="indigo"
                  @click="clearBlockCategory(i, index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-col>
      <v-col cols="3" class="content_category rounded-lg ml-3">
        <div class="mx-2" style="width: 90%">
          <v-row>
            <v-col cols="8">
              <h4 class="mb-1">Sản phẩm mới</h4>
            </v-col>
            <v-col cols="4">
              <v-btn
                class="d-flex justify-end"
                color="primary"
                @click="addBlockProduct()"
              >
                ADD
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-col cols="12"
            v-for="(i, index) in post_config_sidebar.product_ids"
            :key="index"
          >
            <v-row class="ma-0 pa-0">
              <v-col cols="8" class="ma-0 pa-0">
                <v-autocomplete
                  v-model="i.product_id"
                  label="Chọn sản phẩm"
                  :items="productions"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="4" class="ma-0 pa-0">
                <v-btn
                  class="ma-2"
                  outlined
                
                  large
                  color="indigo"
                  @click="clearBlockProduct(i, index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY_POST } from "@/store/modules/category_post";
import { GET_LIST_PRODUCT } from "@/store/modules/production";
import {
  GET_NEW_POST_CONFIGS_SIDEBAR,
  UPDATE_NEW_POST_CONFIGS_SIDEBAR,
} from "@/store/modules/configs";

export default {
  data() {
    return {
      blockCategory: {
        category_post_id: "",
        count: 0,
      },
      blockProduct: {
        product_id: "",
        count: 0,
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      categoryPost: "categoryPost",
      productions: "productions",
      post_config_sidebar: "post_config_sidebar",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY_POST}`);
    await this.$store.dispatch(`${GET_LIST_PRODUCT}`);
    await this.$store.dispatch(`${GET_NEW_POST_CONFIGS_SIDEBAR}`);
  },
  methods: {
    addBlockCategory() {
      this.post_config_sidebar.category_post_ids.push({
        category_post_id: this.blockCategory.category_post_id,   
      });
      this.$forceUpdate();
    },
    clearBlockCategory(i, index) {
      this.post_config_sidebar.category_post_ids.splice(index, 1);
      this.$forceUpdate();
    },
    addBlockProduct() {
      this.post_config_sidebar.product_ids.push({
        product_id: this.blockProduct.product_id,
      });
      this.$forceUpdate();
    },
    clearBlockProduct(i, index) {
      this.post_config_sidebar.product_ids.splice(index, 1);
      this.$forceUpdate();
    },
    save() {
      let param = {
        category_post_ids: JSON.stringify(
          this.post_config_sidebar.category_post_ids
        ),
        product_ids: JSON.stringify(this.post_config_sidebar.product_ids),
      };
      this.$store
        .dispatch(`${UPDATE_NEW_POST_CONFIGS_SIDEBAR}`, param)
        .then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              position: "top-center",
              duration:2000,
            })
            this.$router.push("/manage_page/Page_manager");
          } else {
            alert(data.data.errors);
          }
        });
    },
  },
};
</script>